// these are the categories for the admin page
export const storyCat = [
  {
    value: "wedding",
    label: "Wedding",
  },
  {
    value: "engagement",
    label: "Engagement",
  },
  {
    value: "family",
    label: "Family photography",
  },
  {
    value: "content",
    label: "Content",
  },
];

//these are the categories for client using the contact form
export const photoshootType = [
  {
    value: "wedding",
    label: "Wedding",
  },
  {
    value: "engagement",
    label: "Engagement",
  },
  {
    value: "family",
    label: "Family photoshoot",
  },
  {
    value: "content",
    label: "Content photoshoot",
  },
  {
    value: "elopement",
    label: "Elopement wedding",
  },
  {
    value: "video",
    label: "Video creation",
  },
  {
    value: "book",
    label: "Wedding photo album",
  },
];
